import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';
import { UpdateCalendarService } from './services/update-calendar-api-service';
import { TemaPageDto } from '@jobindsats/typescript-fetch-jobindsats';

@customElement('ji-update-calendar-element')
export class UpdateCalendarElement extends JobindsatsElement(LitElement) {
    static styles = [
        css`
            .calendar-table-row {
                display: flex;
            }

            .calendar-item-1 {
                max-width: 20%;
                min-width: 20%;
                padding: 10px 10px;
            }

            .calendar-item-1-1 {
                max-width: 18%;
                min-width: 18%;
                padding: 10px 10px;
            }

            .calendar-item-2 {
                max-width: 12%;
                min-width: 12%;
                padding: 10px 10px;
            }

            .calendar-item-3 {
                flex-grow: 1;
                min-width: 12%;
                padding: 10px 10px;
            }

            .zebra-bg {
                background: var(--main-zebra);
            }

            .hidden {
                color: transparent;
            }

            .top-bar {
                border-top: 1px solid var(--main-gray-50);
            }

        `
    ];

    static instance = 0;

    @property({
        attribute: 'maaling-id'
    })
    maalingId?: string;

    @property({
        attribute: 'maaling-url'
    })
    maalingUrl?: string;

    @property({
        attribute: 'maaling-name'
    })
    maalingName?: string;

    @property({
        attribute: 'group-name'
    })
    groupName?: string;

    @property({
        attribute: 'zebra'
    })
    zebra?: boolean;

    @property({
        attribute: 'display-groupname'
    })
    displayGroupName?: boolean;

    @property({
        attribute: 'id',
    })
    id = ++UpdateCalendarElement.instance + 'lit-calendar-element';

    @state()
    metadataMaaling?: TemaPageDto;

    maalingService: UpdateCalendarService;

    constructor() {
        super();
        this.maalingService = new UpdateCalendarService();
    }


    connectedCallback() {
        super.connectedCallback();
        if (this.maalingId) {
            this.maalingService.getMetadataMaalingValues({ maalingId: this.maalingId }).then(res => {
                this.metadataMaaling = res;

                this.showCalendar();
            });
        }
    }

    render() {
        var lastPeriod = 'Ingen periode angivet';

        if (this.metadataMaaling?.period?.firstAndLast) {
            lastPeriod = this.metadataMaaling.period?.firstAndLast[1];
        }

        if (this.metadataMaaling) {
            return html`
                <div id="${this.id}" class="calendar-table-row ${this.displayGroupName ? 'top-bar' : ''}">
                    <div class="calendar-item-1 ${this.zebra ? 'zebra-bg' : ''} ${this.displayGroupName ? '' : 'hidden'}">${this.groupName}</div>
                    <a class="calendar-item-1-1 ${this.zebra ? 'zebra-bg' : ''}" href=${this.maalingUrl}>${this.maalingName}</a>
                    <div class="calendar-item-2 ${this.zebra ? 'zebra-bg' : ''}">${this.metadataMaaling.updateInfo?.lastUpdate?.toLocaleDateString('da-DK', { year: "numeric", month: "short", day: "numeric" })}</div>
                    <div class="calendar-item-2 ${this.zebra ? 'zebra-bg' : ''}">${this.metadataMaaling.updateInfo?.nextUpdate?.toLocaleDateString('da-DK', { year: "numeric", month: "short", day: "numeric" })}</div>
                    <div class="calendar-item-2 ${this.zebra ? 'zebra-bg' : ''}">${lastPeriod} </div>
                    <div class="calendar-item-3 ${this.zebra ? 'zebra-bg' : ''}">${this.metadataMaaling.updateFreq}</div>
                </div>
        `;
        }
    }

    showCalendar() {
        document.getElementById('UpdateCalendar')?.classList.remove('calendar-hidden');
    }

}